import settings from 'settings';

const config = {
  filters: {
    user: {
      search: '',
      tags: [],
      allTags: true,
      active: false,
      tagged: []
    },
    activity: {
      search: '',
      tags: [],
      allTags: true,
      tagged: []
    }
  },
  options: {
    activityCreateCount: settings.APP_CONFIG.defaultTimelineActivityCreateCount,
    activityHoursBetween: settings.APP_CONFIG.defaultTimelineActivityHoursBetween,
    timelineMaxDays: settings.APP_CONFIG.defaultTimelineMaxDays,
    timelineSnapMinutes: settings.APP_CONFIG.defaultTimelineSnapMinutes,
    displayTravelLayer: false,
    displayLeaveLayer: false,
    displayAvailabilityLayer: false,
    rosterPivoted: false,
    hideEmptyRows: false,
    assignmentTitleFormat: [],
    hideUnallocatedRows: true,
  },
  display: {
    search: {
      title: 'Details',
      data: data => data
    },
    tags: {
      title: 'Tags',
      data: data => data.map(tag => tag.label)
        .toString()
    },
    allTags: {
      title: 'Use All Tags',
      data: data => (data ? 'Yes' : 'No')
    },
    active: {
      title: 'Hide Inactive Users',
      data: data => (data ? 'Yes' : 'No')
    },
    activityCreateCount: {
      title: 'No. of activities',
      data: data => data
    },
    activityHoursBetween: {
      title: 'Repeat Cycle Hours',
      data: data => data
    },
    timelineSnapMinutes: {
      title: 'Snap minutes',
      data: data => data
    },
    displayTravelLayer: {
      title: 'Travel Bookings',
      data: data => (data ? 'Yes' : 'No')
    },
    displayLeaveLayer: {
      title: 'Leave',
      data: data => (data ? 'Yes' : 'No')
    },
    displayAvailabilityLayer: {
      title: 'Availability',
      data: data => (data ? 'Yes' : 'No')
    },
    rosterPivoted: {
      title: 'Pivot Roster',
      data: data => (data ? 'Yes' : 'No')
    },
    hideEmptyRows: {
      title: 'Hide Empty Rows',
      data: data => (data ? 'Yes' : 'No')
    },
    assignmentTitleFormat: {
      title: 'Assignment Title Format',
      data: data => data
    },
    hideUnallocatedRows: {
      title: 'Hide Unallocated Rows',
      data: data => (data ? 'Yes' : 'No')
    }
  }
};

export default config;
